<template>
    <div class="topcode-wechat-inspect-item" @click="canGoHandle">
        <div class="top">
            <div :class="'flex-center-y state  inspectDevice-state-'+inspectDevice.state">{{stateDICT}}</div>
            <div v-if="inspectDevice.handleMethod!=null"
                 :class="'flex-center-y level  inspectDevice-handleMethod-'+inspectDevice.handleMethod">{{handleMethod}}
            </div>
            <div :class="'flex-center-y state  time'">{{inspectDevice.handleTime}}</div>
        </div>
        <div class="body">
            <div class="content">
                <div class="flex-center-y center">
                    <img :src="productImage"/>
                    <div class="name">
                        <div>{{inspectDevice.deviceName}}</div>
                        <div>{{inspectDevice.deviceSn}}</div>
                    </div>
                </div>
            </div>
            <div class="flex-center right" v-if="canHandle">
                <span>处理</span>
                <van-icon name="arrow"/>
            </div>
        </div>
        <CellGroup v-if="showExtra">
            <Cell value-class="cell-value" title="处理用户" :value="inspectDevice.handleUserName"/>
            <Cell value-class="cell-value" title="处理方式" :value="handleMethod"/>
            <Cell value-class="cell-value" title="处理意见" :value="inspectDevice.handleRemark"/>
            <Cell value-class="cell-value" title="处理照片">
                <UploadImage v-for="(img,index) in imageList" :key="index"
                     slot="extra" :imageList="[img]"
                />

            </Cell>
        </CellGroup>
    </div>
</template>

<script>
    import * as DICT from "@/utils/dict"
    import UploadImage from "@/components/UploadImage";
    import {Cell, CellGroup,} from "vant"
    import {downloadImg} from "@/config"

    export default {
        components: {CellGroup, Cell, UploadImage},
        props: {
            inspectDevice: {type: Object, required: true}
        },
        data() {
            return {
                inspectState: this.$route.params.state,
            };
        },
        computed: {
            productImage() {
                return downloadImg + this.inspectDevice.productImage1
            },
            canHandle() {
                return this.inspectDevice.state == 'UN_HANDLE' && this.inspectState == 'PROCESSING'
            },
            stateDICT() {
                return DICT.getValue('INSPECT_TSAK_DEVICE_STATE', this.inspectDevice.state)
            },
            handleMethod() {
                return DICT.getValue('INSPECT_TSAK_DEVICE_HANDLE_METHOD', this.inspectDevice.handleMethod)
            },
            showExtra() {
                const {handleTime} = this.inspectDevice
                return !!handleTime
            },
            imageList() {
                const list = []
                const {handleImage1, handleImage2, handleImage3, handleImage4} = this.inspectDevice
                handleImage1 && list.push(handleImage1)
                handleImage2 && list.push(handleImage2)
                handleImage3 && list.push(handleImage3)
                handleImage4 && list.push(handleImage4)
                return list
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            getImgIrl(img) {
                return downloadImg + img
            },
            canGoHandle() {
                if (this.inspectDevice.state == "UN_HANDLE" && this.inspectState == 'PROCESSING') {
                    this.$router.push('/inspect/deal/' + this.inspectDevice.id)
                }
            }
        },
        watch: {}
    };
</script>

<style lang="less" scoped>

    .topcode-wechat-inspect-item {
        width: 100%;
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;

        & > .top {
            color: #fff;
            display: flex;
            height: 23px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                width: 60px;
                border-radius: 8px 0px 0px 0px;
                &::before {
                    width: 8px;
                    content: '';
                }
            }
            & > .level {
                height: 100%;
                width: 43px;
                justify-content: center;
            }

            & > .time {
                height: 100%;
                width: calc(100% - 70px);
                justify-content: space-around;

            }
        }

        & > .body {
            display: flex;
            & > .right {
                font-size: 14px;
                font-weight: 500;
                color: #fa7d2d;
            }
            & > .content {
                /*padding: 8px;*/
                width: calc(100% - 50px);
                & > .center {
                    padding: 5px;
                    display: flex;
                    & > img {
                        width: 50px;
                        height: 50px;
                        background: #cccccc;
                      //  border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        font-size: 14px;
                        flex-direction: column;
                        & > div {
                            line-height: 1.5;
                            overflow: hidden;

                        }
                    }
                }

            }
        }
    }
</style>
